// TODO: Move to frontend-common
type GtmJavascriptOptions = {
	readonly id: string;
	readonly gtmServerDomain: string;
};

function getGtmJavascript({ id, gtmServerDomain }: GtmJavascriptOptions) {
	return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://${gtmServerDomain}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${id}');
  `;
}

function getGtmNoScript({ id, gtmServerDomain }: GtmJavascriptOptions): string {
	return `<iframe src="https://${gtmServerDomain}/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`;
}

export type { GtmJavascriptOptions };
export { getGtmJavascript, getGtmNoScript };
